export default __webpack_public_path__ + "static/media/android.9aef72d3.svg";